/* ============================================================
   SECRETS OF TEA — SHOPIFY THEME JS
   ============================================================ */

    // ── Quiz Modal ──
    var quizModalOpen = false;
    var quizTriggered = false;
    var quizFloatVisible = false;

    function openQuizModal() {
      var modal = document.getElementById('quiz-modal');
      var floatBtn = document.getElementById('quiz-float-btn');
      if (!modal) return;
      quizTriggered = true;
      quizModalOpen = true;
      sessionStorage.setItem('sotQuizSeen', '1');
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (floatBtn) floatBtn.classList.add('hidden');
      // Focus the close button on open
      setTimeout(function() {
        var closeBtn = modal.querySelector('.quiz-modal__close');
        if (closeBtn) closeBtn.focus();
      }, 50);
      // Trap focus inside modal
      modal.addEventListener('keydown', quizFocusTrap);
      // Close on Escape
      document.addEventListener('keydown', quizEscHandler);
    }

    function closeQuizModal() {
      var modal = document.getElementById('quiz-modal');
      var floatBtn = document.getElementById('quiz-float-btn');
      if (!modal) return;
      quizModalOpen = false;
      modal.hidden = true;
      document.body.style.overflow = '';
      if (floatBtn) floatBtn.classList.remove('hidden');
      modal.removeEventListener('keydown', quizFocusTrap);
      document.removeEventListener('keydown', quizEscHandler);
      // Return focus to the trigger that opened it
      var floatBtnEl = document.getElementById('quiz-float-btn');
      if (floatBtnEl) floatBtnEl.focus();
    }

    function quizEscHandler(e) {
      if (e.key === 'Escape' && quizModalOpen) closeQuizModal();
    }

    function quizFocusTrap(e) {
      if (e.key !== 'Tab') return;
      var modal = document.getElementById('quiz-modal');
      var focusable = Array.from(modal.querySelectorAll(
        'button:not([disabled]), input, a[href], [tabindex]:not([tabindex="-1"])'
      )).filter(function(el) { return !el.closest('[hidden]') && !el.hidden; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    // ── Floating pill: show only after hero scrolls out of view ──
    (function() {
      var floatBtn = document.getElementById('quiz-float-btn');
      var heroSection = document.querySelector('.hero');
      if (!floatBtn || !heroSection) return;

      var heroObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            // Hero visible — hide the pill
            floatBtn.classList.remove('visible');
            floatBtn.classList.add('hidden');
          } else {
            // Hero scrolled away — show the pill
            floatBtn.classList.remove('hidden');
            floatBtn.classList.add('visible');
          }
        });
      }, { threshold: 0.1 });

      heroObserver.observe(heroSection);
    })();

    // Exit-intent trigger (desktop only — fires after 30s on page AND mouse leaves top)
    var exitIntentReady = false;
    setTimeout(function() { exitIntentReady = true; }, 30000);

    document.addEventListener('mouseleave', function(e) {
      if (
        e.clientY <= 0 &&
        exitIntentReady &&
        !quizTriggered &&
        !quizModalOpen &&
        !sessionStorage.getItem('sotQuizSeen')
      ) {
        openQuizModal();
      }
    });

    // ── Quiz ──
    var quizAnswers = {};
    var quizProducts = {
      fertility:  { name: 'Get Pregnant Fertility Fruits Tea', desc: 'Organic herbs traditionally used to support reproductive wellness and cycle regularity.', price: '$16.50 · Free Shipping', img: 'https://cdn.shopify.com/s/files/1/1683/3199/files/1_b5d09d4a-7dae-4d74-8150-781a8104f18b.png?v=1762796069', link: '/products/get-pregnant-fertility-fruits-tea', heading: 'Your fertility journey starts here.' },
      pregnancy:  { name: 'Prenatal Wellness Tea', desc: 'Caffeine-free herbal blend traditionally used during pregnancy to ease nausea, support calm, and nourish.', price: '$15.97 · Free Shipping', img: 'https://cdn.shopify.com/s/files/1/1683/3199/files/1_a35d6abf-38b3-4e28-af6f-fe04380e6b75.png?v=1763314286', link: '/#bestsellers', heading: 'Nourish yourself and your baby.' },
      nursing:    { name: 'Lemongrass Lactation Tea', desc: 'Organic herbal blend traditionally used to support breast milk supply and postpartum recovery.', price: '$15.97 · Free Shipping', img: 'https://cdn.shopify.com/s/files/1/1683/3199/files/1_a35d6abf-38b3-4e28-af6f-fe04380e6b75.png?v=1763314286', link: '/#bestsellers', heading: 'Support your nursing journey.' },
      baby:       { name: 'Babies Magic Tea', desc: 'USDA Organic herbal colic and gas relief. Pediatrician recommended. Works in under 30 minutes.', price: '$15.97 · Free Shipping', img: 'https://cdn.shopify.com/s/files/1/1683/3199/files/1_a35d6abf-38b3-4e28-af6f-fe04380e6b75.png?v=1763314286', link: '/products/babies-magic-tea', heading: 'Relief for your baby — tonight.' },
      sleep:      { name: 'Valerian Deep Sleep Tea', desc: 'USDA Organic herbal blend traditionally used to support deep, restful sleep — naturally.', price: '$15.97 · Free Shipping', img: 'https://cdn.shopify.com/s/files/1/1683/3199/files/1_b5d09d4a-7dae-4d74-8150-781a8104f18b.png?v=1762796069', link: '/#bestsellers', heading: 'Your body deserves to rest.' },
      wellness:   { name: 'Detox & Wellness Tea', desc: 'A gentle daily cleanse with organic herbs traditionally used to support digestion and vitality.', price: '$15.97 · Free Shipping', img: 'https://cdn.shopify.com/s/files/1/1683/3199/files/1_b5d09d4a-7dae-4d74-8150-781a8104f18b.png?v=1762796069', link: '/#bestsellers', heading: 'Start your wellness ritual.' }
    };

    function quizAnswer(step, value) {
      quizAnswers['step' + step] = value;
      var progress = (step / 3) * 100;
      document.getElementById('quizProgress').style.width = progress + '%';

      if (step < 3) {
        document.getElementById('quizStep' + step).classList.remove('active');
        document.getElementById('quizStep' + (step + 1)).classList.add('active');
      } else {
        document.getElementById('quizStep3').classList.remove('active');
        showQuizResult();
      }
    }

    function showQuizResult() {
      var stage = quizAnswers.step1 || 'baby';
      var product = quizProducts[stage] || quizProducts.baby;

      document.getElementById('quizResultHeading').innerHTML = product.heading.replace(/\.$/, '.<br>') + ' <em>We found your match.</em>';
      document.getElementById('quizResultDesc').textContent = 'Based on where you are in your journey, we recommend:';
      document.getElementById('quizResultImg').src = product.img;
      document.getElementById('quizResultImg').alt = product.name;
      document.getElementById('quizResultName').textContent = product.name;
      document.getElementById('quizResultProductDesc').textContent = product.desc;
      document.getElementById('quizResultPrice').textContent = product.price;
      document.getElementById('quizResultLink').href = product.link;

      document.getElementById('quizProgress').style.width = '100%';
      document.getElementById('quizResult').classList.add('active');
    }

    function quizEmailSubmit() {
      var email = document.getElementById('quizEmail').value;
      if (!email || !email.includes('@')) {
        document.getElementById('quizEmail').focus();
        return;
      }
      var btn = document.querySelector('.quiz-email-form__btn');
      btn.textContent = '✓ Sent!';
      btn.style.background = '#2D6A4F';
      btn.disabled = true;
      // In production: POST to Klaviyo/email list
      var link = document.getElementById('quizResultLink');
      link.style.display = 'inline-flex';
      link.textContent = 'Shop Your Match →';
    }

    function quizRestart() {
      quizAnswers = {};
      ['quizStep1','quizStep2','quizStep3'].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el.classList.remove('active');
      });
      var result = document.getElementById('quizResult');
      if (result) result.classList.remove('active');
      var step1 = document.getElementById('quizStep1');
      if (step1) step1.classList.add('active');
      var progress = document.getElementById('quizProgress');
      if (progress) {
        progress.style.width = '0%';
        progress.parentElement && progress.parentElement.setAttribute('aria-valuenow', '0');
      }
      var btn = document.querySelector('.quiz-email-form__btn');
      if (btn) { btn.textContent = 'Send'; btn.style.background = ''; btn.disabled = false; }
      var emailInput = document.getElementById('quizEmail');
      if (emailInput) emailInput.value = '';
      // Focus first question after restart
      setTimeout(function() {
        var firstOpt = document.querySelector('#quizStep1 .quiz-option');
        if (firstOpt) firstOpt.focus();
      }, 50);
    }

    // ── Intersection Observer for reveal animations ──
    (function() {
      const revealEls = document.querySelectorAll('.reveal, .reveal-stagger');
      if (!revealEls.length) return;

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px 0px 80px 0px'
      });

      // Immediately reveal any elements already in or above the viewport
      revealEls.forEach(function(el) {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight + 100) {
          el.classList.add('visible');
        } else {
          observer.observe(el);
        }
      });
    })();

    // ── Video Wall ──
    (function() {
      var track = document.getElementById('vw-track');
      if (!track) return;

      // Autoplay on viewport enter
      var cards = track.querySelectorAll('.video-card');
      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var card = entry.target;
          var video = card.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            video.play().then(function() {
              card.classList.remove('is-paused');
            }).catch(function() {});
          } else {
            video.pause();
            card.classList.add('is-paused');
          }
        });
      }, { threshold: 0.5 });

      cards.forEach(function(card) { videoObserver.observe(card); });

      // Progress bar
      cards.forEach(function(card) {
        var video = card.querySelector('video');
        var fill = card.querySelector('.video-card__progress-fill');
        if (!video || !fill) return;
        video.addEventListener('timeupdate', function() {
          if (video.duration) {
            fill.style.width = (video.currentTime / video.duration * 100) + '%';
          }
        });
      });

      // Make video cards keyboard focusable and labelled
      cards.forEach(function(card) {
        card.setAttribute('tabindex', '0');
        var quote = card.getAttribute('data-quote') || '';
        var name = card.getAttribute('data-name') || '';
        card.setAttribute('aria-label', 'Customer video: ' + (quote ? '\u201C' + quote + '\u201D' : '') + (name ? ' — ' + name : '') + '. Press Enter or Space to play or pause.');
      });

      // Sound toggle with aria-pressed
      cards.forEach(function(card) {
        var btn = card.querySelector('.video-card__sound');
        var video = card.querySelector('video');
        if (!btn || !video) return;
        btn.setAttribute('aria-pressed', 'false');
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          video.muted = !video.muted;
          btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          btn.querySelector('.icon-muted').style.display = video.muted ? '' : 'none';
          btn.querySelector('.icon-unmuted').style.display = video.muted ? 'none' : '';
        });
      });

      // Click OR keyboard (Enter/Space) on card to play/pause
      function toggleCardVideo(card) {
        var video = card.querySelector('video');
        if (!video) return;
        if (video.paused) {
          video.play().then(function() { card.classList.remove('is-paused'); }).catch(function(){});
        } else {
          video.pause();
          card.classList.add('is-paused');
        }
      }

      cards.forEach(function(card) {
        card.addEventListener('click', function(e) {
          if (e.target.closest('.video-card__sound')) return;
          toggleCardVideo(card);
        });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleCardVideo(card);
          }
        });
      });

      // Arrow navigation
      var prevBtn = document.getElementById('vw-prev');
      var nextBtn = document.getElementById('vw-next');
      var cardW = 220 + 16;
      if (prevBtn) prevBtn.addEventListener('click', function() {
        stopAutoScroll();
        track.scrollBy({ left: -cardW * 3, behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function() {
        stopAutoScroll();
        track.scrollBy({ left: cardW * 3, behavior: 'smooth' });
      });

      // Auto-scroll
      var autoTimer = null;
      function startAutoScroll() {
        autoTimer = setInterval(function() {
          var maxScroll = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= maxScroll - 4) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: cardW, behavior: 'smooth' });
          }
        }, 3000);
      }
      function stopAutoScroll() {
        clearInterval(autoTimer);
      }

      // Start auto-scroll, pause on hover/touch
      startAutoScroll();
      track.addEventListener('mouseenter', stopAutoScroll);
      track.addEventListener('mouseleave', startAutoScroll);
      track.addEventListener('touchstart', stopAutoScroll, { passive: true });
      track.addEventListener('touchend', function() {
        setTimeout(startAutoScroll, 4000);
      }, { passive: true });

      // Drag to scroll
      var isDown = false, startX, scrollLeft;
      track.addEventListener('mousedown', function(e) {
        isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
      });
      track.addEventListener('mouseleave', function() { isDown = false; });
      track.addEventListener('mouseup', function() { isDown = false; });
      track.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        track.scrollLeft = scrollLeft - (x - startX) * 1.5;
      });
    })();

    // ── Sticky nav shadow on scroll ──
    (function() {
      const nav = document.querySelector('.nav');
      if (!nav) return;

      var ticking = false;
      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            if (window.scrollY > 20) {
              nav.classList.add('scrolled');
            } else {
              nav.classList.remove('scrolled');
            }
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    })();

    // ── Mobile menu toggle with inert + focus trap ──
    (function() {
      var btn = document.querySelector('.nav__hamburger');
      var menu = document.getElementById('mobile-menu');
      if (!btn || !menu) return;

      // Start inert (closed)
      menu.setAttribute('inert', '');

      function openMenu() {
        menu.classList.add('open');
        btn.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
        menu.removeAttribute('inert');
        document.body.style.overflow = 'hidden';
        // Move focus to first link
        var firstLink = menu.querySelector('a');
        if (firstLink) setTimeout(function() { firstLink.focus(); }, 50);
      }

      function closeMenu() {
        menu.classList.remove('open');
        btn.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        menu.setAttribute('inert', '');
        document.body.style.overflow = '';
        btn.focus();
      }

      btn.addEventListener('click', function() {
        if (menu.classList.contains('open')) { closeMenu(); } else { openMenu(); }
      });

      // Close on link click
      menu.querySelectorAll('a').forEach(function(link) {
        link.addEventListener('click', closeMenu);
      });

      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && menu.classList.contains('open')) { closeMenu(); }
      });

      // Focus trap — keep Tab inside menu when open
      menu.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
        var focusable = Array.from(menu.querySelectorAll('a, button'));
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      });
    })();

    // ── Add to Cart — aria-live announcement ──
    (function() {
      var announcer = document.getElementById('a11y-announce');
      document.querySelectorAll('.product-card__add').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var label = btn.getAttribute('aria-label') || 'Item';
          if (announcer) announcer.textContent = label.replace('Add ', '') + ' added to cart.';
          // Reset after 3s so next click re-announces
          setTimeout(function() { if (announcer) announcer.textContent = ''; }, 3000);
        });
      });
    })();

    // ── Email form accessible validation ──
    (function() {
      var form = document.querySelector('.subscribe__form');
      var input = document.getElementById('subscribe-email');
      var error = document.getElementById('subscribe-email-error');
      if (!form || !input || !error) return;
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (!input.value || !input.value.includes('@')) {
          error.textContent = 'Please enter a valid email address.';
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        } else {
          error.textContent = '';
          input.setAttribute('aria-invalid', 'false');
          var announcer = document.getElementById('a11y-announce');
          if (announcer) announcer.textContent = 'Thank you! You\'ve been subscribed.';
          input.value = '';
        }
      });
      input.addEventListener('input', function() {
        if (input.getAttribute('aria-invalid') === 'true') {
          error.textContent = '';
          input.setAttribute('aria-invalid', 'false');
        }
      });
    })();

    // ── Smooth scroll for anchor links ──
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  

/* ── FAQ toggle (product pages) ── */
function toggleFaq(el) {
  var item = el.parentElement;
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(i) { i.classList.remove('open'); });
  if (!isOpen) item.classList.add('open');
}
